<template>
  <div class='text' v-if="data.card_resource.length">
    <p v-html="data.card_resource[0].description"></p>
    <amaze-userfile v-for="userfile in data.card_resource[0].userfile" :key="userfile.id" :userfile="userfile"></amaze-userfile>
  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.text {
  font-size: 14px;
}
</style>
<script>
export default {
  props: ["data"]
};
</script>
